<SvgIcon :content="icons[name] || ''" :fill="fill" :size="size" :use-current-color="useCurrentColor"><slot></slot></SvgIcon>